<template>
  <div class="top-nav-wrapper">
    
    <div class="top-nav clearfix">
      <div class="top-nav-list">
        
        <a @click="goToFn('/index')" class="top-nav-home">
          <img class="logo" src="../../../assets/img/xgk.png" alt="" />
        </a>

        <!-- <a href="/zsgs/zhangcheng/">招生章程</a>
        <a href="/sch/">院校库</a>
        <a href="/zyk/pub/myd/schAppraisalTop.action">院校满意度</a>
        <a href="/zyk/pub/myd/specAppraisalTop.action">专业满意度</a>
        <a href="/zyk/pub/zytj/recommendTop.action">专业推荐</a>
        <a href="/zyk/zybk/">专业知识库</a>
        <a href="/zyk/zybk/zyjd/listPage/">专业解读</a>
        <a href="/zxdy/">咨询周</a>
        <a
          href="/zxdy/zxs--method-listDefault,forumid-6267733,year-2007,start-0.dhtml"
          >咨询室</a
        >
        <a href="/zyck/" target="_blank">高考填报志愿参考</a> -->
      </div>
      <div class="top-nav-load clearfix">
        <a class="hover" @click="goToFn('/index')">首页</a>
        <!-- <a class="hover" @click="goToFn('/m-index/hld')">个性测评</a>
        <a
          class="hover"
          v-if="roles.includes('Aadmin') === true"
          @click="goToFn('/adaptation')"
          >子系统业务数据维护</a
        > -->
        <a
          class="login"
          v-if="roles.length === 0"
          @click="goToFn('/login')"
          >登录</a
        >
        <a v-else class="login">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ username }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">个人信息</el-dropdown-item>
              <el-dropdown-item command="logout">退出</el-dropdown-item>
            </el-dropdown-menu> 
          </el-dropdown>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { removeToken } from '@/utils/auth'
export default {
  computed: {
    username() {
      console.log(this.$store.getters.name);
      return this.$store.getters.name;
    },
    roles() {
      return this.$store.getters.roles;
    },
  },
  methods: {
    goToFn(url) {
      if (url.indexOf("hld") > -1 && this.$store.getters.roles.length === 0) {
        this.$router.push({path: "/login",
          query: {
            href: '/m-index/hld'
          }
        });
      }
      this.$router.push(url);
    },
    handleCommand (command) {
      console.log(command)
      if (command === 'logout') {
        removeToken()
        this.$store.dispatch("setDataEmpty")
        this.$store.state.routes = []
        // location.reload()
        this.$router.replace('/index')
      }
    }
  },
};
</script>
<style lang="less" scoped>
/**
     * description: 吊顶;
     * author: myx;
     * date: 2017-12;
     */
.top-nav-wrapper {
  width: 100%;
  height: 50px;
  line-height: 50px;
  // background: #f5f5f5;
  border-bottom: 1px solid #d6d6d6;
  font-size: 12px;
  overflow: hidden;
  position: relative;
  top: 0;
  width: 100%;
  // margin-bottom: 20px;
}

.top-nav-wrapper a {
  color: #333;
}

.top-nav-wrapper a.hot {
  color: #ee6464;
}

.top-nav-wrapper a:hover {
  text-decoration: underline;
}

.top-nav-wrapper .top-nav {
  width: 80%;
  margin: 0 auto;
  min-width: 80%;
}

.top-nav-wrapper .top-nav-list {
  float: left;
  width: 300px;
  height: 50px;
}

.top-nav-wrapper .top-nav-list a {
  margin: 0 10px;
}

.top-nav-wrapper .top-nav-list a.top-nav-home {
  display: inline-block;
  width: 75px;
  height: 65px;
  margin-right: 15px;
  margin-left: 30px;
  margin-top: -5px;
  background-image: url("../../../assets/img/icon.jpeg");
  background-image: -webkit-image-set(
    url("../../../assets/logo.png") 1x,
    url("../../../assets/logo.png") 2x
  );
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 0 0px;
  color: #46a0fc;
  font-weight: bold;
  vertical-align: middle;
  position: relative;
  .logo {
    position: absolute;
    top:20px;
    left: -40px;
    width: 25px;
    height: 25px;
  }
}

.top-nav-wrapper .top-nav-list a.top-nav-home:hover {
  text-decoration: none;
}

.top-nav-wrapper .top-nav-load {
  float: right;
  text-align: right;
  display: flex;
  align-items: center;
  cursor: pointer;
  a + a {
    margin-left: 20px;
  }
  .hover:hover {
    color: #46a0fc;
  }
}

.top-nav-wrapper .top-nav-load a {
  font-size: 14px;
  text-decoration: none;
  display: block;
}
.login {
  margin-left: 50px !important;
  height: 35px;
  // width: 50px;
  border-radius: 10px;
  padding: 0px 10px 0 15px;
  letter-spacing: 5px;
  // text-align: center;
  color: #000;
  font-weight: bold;
  line-height: 35px;
  box-shadow: -2px 0px 5px 1px #e7ebf0, 0px -2px 5px 1px #e7ebf0,
    2px 0px 5px 1px #e7ebf0, 0px 2px 5px 1px #e7ebf0;
}

.top-nav-wrapper a.username {
  color: #46a0fc;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  float: left;
}
</style>